import { Spin } from 'antd';
import { useEffect } from 'react';
import LoadingOverlayWrapper from 'react-loading-overlay-ts';
import { BrowserRouter as Router } from 'react-router-dom';
import AppLayout from './Layout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useAuth from './hooks/useAuth';
import useLoading from './hooks/useLoading';
import { loggedInUser } from './redux/actions/auth';

const App = () => {
  const { token } = useAuth();
  const { loading } = useLoading();

  useEffect(() => {
    if (token) {
      loggedInUser();
    }
  }, [token]);

  return (
    <div className="App">
      <LoadingOverlayWrapper
        spinner={<Spin fullscreen size="large" />}
        active={loading}
        styles={{
          overlay: (base) => ({
            ...base,
            background: 'rgba(255, 255, 255, 0.5)',
            height: '100vh',
            zIndex: 9999,
          }),
        }}
      >
        <Router>
          <AppLayout />
        </Router>
      </LoadingOverlayWrapper>
      <ToastContainer />
    </div>
  );
};

export default App;
